import { useQuery } from '@tanstack/react-query';
import reportesService, {
  type Filtros,
  type RespuestaCompras,
  type RespuestaConciliacion,
  type RespuestaConteo,
  type RespuestaExistencias,
  type RespuestaLotes,
} from '../services/reportesService';

/**
 * Hooks de los reportes (PROMPT_N°054).
 *
 * `staleTime` corto: un reporte de inventario que muestra datos de hace un
 * minuto no sirve para cuadrar bodega. `keepPreviousData` para que la tabla
 * no parpadee al mover un filtro.
 */

export const reportesKeys = {
  all: ['reportes'] as const,
  uno: (nombre: string, f: Filtros) => [...reportesKeys.all, nombre, f] as const,
};

const opciones = {
  keepPreviousData: true,
  staleTime: 15 * 1000,
};

/**
 * `habilitado` existe por la vista de impresión: ahí hay que declarar los
 * cinco hooks (las reglas de hooks no permiten llamarlos condicionalmente)
 * pero sólo uno debe pegarle al servidor. Sin esto, abrir la impresión de
 * un reporte disparaba los cinco.
 */

export const useExistencias = (f: Filtros, habilitado = true) =>
  useQuery<RespuestaExistencias>({
    queryKey: reportesKeys.uno('existencias', f),
    queryFn: () => reportesService.existencias(f),
    enabled: habilitado,
    ...opciones,
  });

export const useConciliacion = (f: Filtros, habilitado = true) =>
  useQuery<RespuestaConciliacion>({
    queryKey: reportesKeys.uno('conciliacion', f),
    queryFn: () => reportesService.conciliacion(f),
    enabled: habilitado,
    ...opciones,
  });

export const useLotesReporte = (f: Filtros, habilitado = true) =>
  useQuery<RespuestaLotes>({
    queryKey: reportesKeys.uno('lotes', f),
    queryFn: () => reportesService.lotes(f),
    enabled: habilitado,
    ...opciones,
  });

export const useComprasReporte = (f: Filtros, habilitado = true) =>
  useQuery<RespuestaCompras>({
    queryKey: reportesKeys.uno('compras', f),
    queryFn: () => reportesService.compras(f),
    enabled: habilitado,
    ...opciones,
  });

export const useConteo = (f: Filtros, habilitado = true) =>
  useQuery<RespuestaConteo>({
    queryKey: reportesKeys.uno('conteo', f),
    queryFn: () => reportesService.conteo(f),
    enabled: habilitado,
    ...opciones,
  });
